import { getConsent, subscribe } from './store';
import logger from './logger';
import type { ConsentHandler } from './types';

// Tracks the active unregister fn per service id so a re-registration (e.g. React strict-mode double-invoke or remount) replaces rather than duplicates the handler.
const registrations = new Map<string, () => void>();

/**
 * Registers a service's consent handler. The handler is invoked immediately with the current snapshot (replay) so late registrants pick up a decision that was already made, and again on every subsequent consent change. Returns an unregister fn.
 */
export const registerConsentHandler = (id: string, handler: ConsentHandler): (() => void) => {
  registrations.get(id)?.();

  const unsubscribe = subscribe(handler);
  registrations.set(id, unsubscribe);

  logger.debug(`registered handler "${id}"; replaying current snapshot`, getConsent());
  handler(getConsent());

  return () => {
    logger.debug(`unregistered handler "${id}"`);
    unsubscribe();
    if (registrations.get(id) === unsubscribe) {
      registrations.delete(id);
    }
  };
};
